'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dDashboard$002dPage$0024 from "./presto.-Dashboard-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002499 from "./presto.-Presto-Router$$anon$99.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$98() {
  this.bqd = null;
  this.bq5 = null;
  this.bq6 = false;
  this.bqe = null;
  this.bqf = false;
  this.bqi = null;
  this.bqb = null;
  this.bqc = false;
  this.bq7 = null;
  this.bq8 = false;
  this.bq9 = null;
  this.bqa = false;
  this.bqg = false;
  this.bqh = false;
  this.bqd = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bqi = "DashboardPage";
}
export { $c_Lpresto_PrestoRouter$$anon$98 as $c_Lpresto_PrestoRouter$$anon$98 };
$p = $c_Lpresto_PrestoRouter$$anon$98.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$98;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$98() {
}
export { $h_Lpresto_PrestoRouter$$anon$98 as $h_Lpresto_PrestoRouter$$anon$98 };
$h_Lpresto_PrestoRouter$$anon$98.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bqd;
});
$p.L = (function() {
  if ((!this.bq6)) {
    this.bq5 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bq6 = true;
  }
  return this.bq5;
});
$p.O = (function() {
  if ((!this.bqf)) {
    this.bqe = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bqf = true;
  }
  return this.bqe;
});
$p.E = (function() {
  return this.bqi;
});
$p.t = (function() {
  if ((!this.bqc)) {
    this.bqb = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bqc = true;
  }
  return this.bqb;
});
$p.M = (function() {
  if ((!this.bq8)) {
    this.bq7 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bq8 = true;
  }
  return this.bq7;
});
$p.Q = (function() {
  if ((!this.bqa)) {
    this.bq9 = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002499.$c_Lpresto_PrestoRouter$$anon$99();
    this.bqa = true;
  }
  return this.bq9;
});
$p.w = (function() {
  if ((!this.bqh)) {
    this.bqg = false;
    this.bqh = true;
  }
  return this.bqg;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee604) => ((p) => \u03b4scrutinee604))($j_presto$002e$002dDashboard$002dPage$0024.$m_Lpresto_DashboardPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$98 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$98, "presto.PrestoRouter$$anon$98", ({
  P7: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$98 as $d_Lpresto_PrestoRouter$$anon$98 };
//# sourceMappingURL=presto.-Presto-Router$$anon$98.js.map
